export default __webpack_public_path__ + "static/media/backpack2.797de287.jpeg";